import React, { useState } from 'react';
import {
  createPayroll,
  deletePayrollPeriod,
  deletePayrollRow,
  fetchPayrollConsult,
  updatePayrollConsult,
} from '../../services/adminService';

const MESES = [
  { id: '01', label: 'Enero' },
  { id: '02', label: 'Febrero' },
  { id: '03', label: 'Marzo' },
  { id: '04', label: 'Abril' },
  { id: '05', label: 'Mayo' },
  { id: '06', label: 'Junio' },
  { id: '07', label: 'Julio' },
  { id: '08', label: 'Agosto' },
  { id: '09', label: 'Septiembre' },
  { id: '10', label: 'Octubre' },
  { id: '11', label: 'Noviembre' },
  { id: '12', label: 'Diciembre' },
];

const OPCIONES = [
  { id: 'opcion_1', label: 'Opción 1 (15 y 30)' },
  { id: 'opcion_2', label: 'Opción 2 (5 y 20)' },
  { id: 'opcion_3', label: 'Opción 3 (10 y 25)' },
  { id: 'todas', label: 'Opción 4 (Todas)' },
];

const anios = () => {
  const actual = new Date().getFullYear();
  const lista = [];

  for (let anio = actual - 1; anio <= actual + 1; anio += 1) {
    lista.push(String(anio));
  }

  return lista;
};

const numero = (valor) => {
  const cantidad = parseFloat(String(valor === undefined || valor === null ? '' : valor).replace(',', '.'));

  return Number.isFinite(cantidad) ? cantidad : 0;
};

const dinero = (valor) => numero(valor).toFixed(2);

const recalcular = (fila, horasExtra, otros) => {
  const montoExtra = numero(horasExtra) * numero(fila.salario_hora);
  const otrosMonto = numero(otros);
  const quincena = numero(fila.salario_quincenal);
  const base = quincena + montoExtra - numero(fila.monto_dias) - numero(fila.monto_horas) - otrosMonto;
  const sso = fila.deduccion_seguro_social ? (numero(fila.porcentaje_seguro_social) * base) / 100 : 0;
  const seguro = fila.deduccion_seguro_educativo ? (numero(fila.porcentaje_seguro_educativo) * base) / 100 : 0;
  const islr = fila.calcula_islr && base >= 424 ? ((base - 423.07) * 15) / 100 : 0;
  const subtotal =
    quincena +
    numero(fila.prima_quincena) +
    montoExtra -
    numero(fila.monto_dias) -
    numero(fila.monto_horas) -
    otrosMonto -
    sso -
    seguro -
    islr;

  return {
    ...fila,
    horas_extra: horasExtra,
    monto_horas_extra: dinero(montoExtra),
    otros_descuentos: otros,
    monto_sso: dinero(sso),
    monto_seguro_educativo: dinero(seguro),
    islr: dinero(islr),
    subtotal: dinero(subtotal),
    total_neto: dinero(subtotal),
  };
};

const claseFila = (tipo) =>
  tipo === 'honorarios_profesionales' ? 'nomina-fila--honorarios' : 'nomina-fila--hora';

const NominaConsultar = ({ sessionId, onSalir }) => {
  const hoy = new Date();
  const [quincena, setQuincena] = useState(hoy.getDate() <= 15 ? '1' : '2');
  const [mes, setMes] = useState(String(hoy.getMonth() + 1).padStart(2, '0'));
  const [anio, setAnio] = useState(String(hoy.getFullYear()));
  const [opcion, setOpcion] = useState('');
  const [filas, setFilas] = useState([]);
  const [disponibles, setDisponibles] = useState([]);
  const [cerrada, setCerrada] = useState(false);
  const [consultado, setConsultado] = useState(false);
  const [trabajadorId, setTrabajadorId] = useState('');
  const [agregarAbierto, setAgregarAbierto] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');

  const periodo = { quincena, mes, anio };
  const nombreMes = (MESES.find((item) => item.id === mes) || {}).label || mes;
  const visibles = filas.filter((fila) => {
    if (!opcion) {
      return false;
    }

    if (opcion === 'todas') {
      return true;
    }

    return fila.opcion_impresion === opcion;
  });

  const aplicarConsulta = (datos) => {
    setFilas(datos.filas || []);
    setDisponibles(datos.disponibles || []);
    setCerrada(Boolean(datos.cerrada));
    setConsultado(true);
  };

  const consultar = () => {
    setCargando(true);
    setError('');
    setAviso('');

    fetchPayrollConsult(sessionId, periodo)
      .then((datos) => {
        aplicarConsulta(datos);

        if (!datos.filas || datos.filas.length === 0) {
          setAviso('No existe nómina creada para esa quincena.');
        }
      })
      .catch((requestError) => {
        setFilas([]);
        setDisponibles([]);
        setConsultado(false);
        setError(requestError.message || 'No se pudo consultar la nómina.');
      })
      .finally(() => {
        setCargando(false);
      });
  };

  const cambiarFila = (id, campo, valor) => {
    setFilas((actuales) =>
      actuales.map((fila) => {
        if (fila.id !== id) {
          return fila;
        }

        const horasExtra = campo === 'horas_extra' ? valor : fila.horas_extra;
        const otros = campo === 'otros_descuentos' ? valor : fila.otros_descuentos;

        return recalcular(fila, horasExtra, otros);
      })
    );
  };

  const actualizar = () => {
    if (visibles.length === 0) {
      setError('Selecciona una opción que tenga personas.');
      setAviso('');
      return;
    }

    setCargando(true);
    setError('');
    setAviso('');

    updatePayrollConsult(
      sessionId,
      periodo,
      visibles.map((fila) => ({
        id: fila.id,
        horas_extra: fila.horas_extra,
        otros_descuentos: fila.otros_descuentos,
      }))
    )
      .then((datos) => {
        aplicarConsulta(datos);
        setAviso('Nómina actualizada.');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo actualizar la nómina.');
      })
      .finally(() => {
        setCargando(false);
      });
  };

  const eliminarFila = (fila) => {
    if (!window.confirm('¿Eliminar a ' + fila.nombre + ' de esta nómina?')) {
      return;
    }

    setCargando(true);
    setError('');
    setAviso('');

    deletePayrollRow(sessionId, periodo, fila.id)
      .then((datos) => {
        aplicarConsulta(datos);
        setAviso(fila.nombre + ' se eliminó de la nómina.');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo eliminar la fila.');
      })
      .finally(() => {
        setCargando(false);
      });
  };

  const eliminarQuincena = () => {
    if (!opcion || visibles.length === 0) {
      setError('Selecciona una opción que tenga personas.');
      setAviso('');
      return;
    }

    const etiqueta = (OPCIONES.find((item) => item.id === opcion) || {}).label || 'la opción';

    if (
      !window.confirm(
        '¿Eliminar las ' +
          visibles.length +
          ' personas visibles de la quincena ' +
          quincena +
          ' de ' +
          nombreMes +
          ' ' +
          anio +
          ' (' +
          etiqueta +
          ')? Esta acción no se puede deshacer.'
      )
    ) {
      return;
    }

    setCargando(true);
    setError('');
    setAviso('');

    deletePayrollPeriod(
      sessionId,
      periodo,
      visibles.map((fila) => fila.id)
    )
      .then((datos) => {
        aplicarConsulta(datos);
        setAviso('Se eliminaron ' + (datos.eliminados || 0) + ' personas de la opción visible.');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo eliminar la quincena.');
      })
      .finally(() => {
        setCargando(false);
      });
  };

  const agregar = () => {
    if (!trabajadorId) {
      setError('Selecciona un trabajador.');
      setAviso('');
      return;
    }

    setCargando(true);
    setError('');
    setAviso('');

    createPayroll(sessionId, { ...periodo, usuario_id: Number(trabajadorId) })
      .then((datos) => {
        const fuera = datos.omitidas || [];
        const nuevas = datos.creadas || [];

        if (fuera.length > 0) {
          setError(fuera.map((fila) => fila.nombre + ' no se creó: ' + fila.motivo).join(' '));
        }

        if (nuevas.length > 0) {
          setAviso('Trabajador agregado a la nómina.');
        } else if (fuera.length === 0) {
          setAviso('Esa persona ya está en la quincena.');
        }

        setTrabajadorId('');
        return fetchPayrollConsult(sessionId, periodo);
      })
      .then((datos) => {
        if (datos) {
          aplicarConsulta(datos);
        }
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo agregar el trabajador.');
      })
      .finally(() => {
        setCargando(false);
      });
  };

  return (
    <div className="admin-pre-overlay" role="presentation">
      <div className="admin-pre-panel nomina-consulta-panel" role="dialog" aria-modal="true">
        <div className="admin-pre-bar">
          <h2>
            {consultado
              ? 'Nómina creada a la ' + quincena + ' quincena ' + nombreMes + ' ' + anio
              : 'Consultar nómina'}
          </h2>
          <button type="button" className="admin-pre-close" onClick={onSalir} aria-label="Cerrar">
            ×
          </button>
        </div>
        <p className="admin-muted">
          Elige la quincena y la opción de impresión. Los días y las horas no trabajadas salen de los
          descuentos y no se editan aquí. Si la quincena está cerrada, la consulta queda solo para ver.
        </p>
        {error ? (
          <div className="admin-alert admin-alert--error" role="alert">
            {error}
          </div>
        ) : null}
        {aviso ? (
          <div className="admin-alert admin-alert--success" role="status">
            {aviso}
          </div>
        ) : null}
        <div className="admin-form-row">
          <label className="admin-field">
            <span>Quincena</span>
            <select value={quincena} onChange={(event) => setQuincena(event.target.value)}>
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </label>
          <label className="admin-field">
            <span>Mes</span>
            <select value={mes} onChange={(event) => setMes(event.target.value)}>
              {MESES.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              ))}
            </select>
          </label>
          <label className="admin-field">
            <span>Año</span>
            <select value={anio} onChange={(event) => setAnio(event.target.value)}>
              {anios().map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </label>
          <label className="admin-field">
            <span>Imprimir</span>
            <select value={opcion} onChange={(event) => setOpcion(event.target.value)}>
              <option value="">Seleccione opción</option>
              {OPCIONES.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="admin-pre-actions">
          <button type="button" className="admin-btn admin-btn--primary" onClick={consultar} disabled={cargando}>
            {cargando ? 'Consultando…' : 'Consultar'}
          </button>
          {!cerrada ? (
            <button type="button" className="admin-btn admin-btn--secondary" onClick={actualizar} disabled={cargando}>
              Actualizar nómina
            </button>
          ) : null}
          {!cerrada ? (
            <button
              type="button"
              className="admin-btn admin-btn--secondary"
              onClick={() => setAgregarAbierto((abierto) => !abierto)}
              disabled={cargando || !consultado}
            >
              Adicionar trabajador
            </button>
          ) : null}
          {!cerrada ? (
            <button type="button" className="admin-btn admin-btn--danger" onClick={eliminarQuincena} disabled={cargando}>
              Eliminar quincena
            </button>
          ) : null}
          <button type="button" className="admin-btn admin-btn--secondary" onClick={onSalir}>
            Salir
          </button>
        </div>
        {cerrada ? <p className="admin-muted">Esta quincena está cerrada.</p> : null}
        {!cerrada && agregarAbierto ? (
          <div className="admin-form-row">
            <label className="admin-field">
              <span>Trabajador</span>
              <select value={trabajadorId} onChange={(event) => setTrabajadorId(event.target.value)}>
                <option value="">Seleccione</option>
                {disponibles.map((persona) => (
                  <option key={persona.id} value={String(persona.id)}>
                    {persona.nombre}
                  </option>
                ))}
              </select>
            </label>
            <button type="button" className="admin-btn admin-btn--primary" onClick={agregar} disabled={cargando}>
              Agregar
            </button>
          </div>
        ) : null}
        {consultado && !opcion ? <p className="admin-muted">Selecciona una opción para ver la nómina.</p> : null}
        {consultado && opcion && visibles.length === 0 ? (
          <p className="admin-muted">No hay personas para esta opción.</p>
        ) : null}
        {visibles.length > 0 ? (
          <div className="admin-table-wrap nomina-consulta-tabla">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Nombre</th>
                  <th>Horas</th>
                  <th>$/Hora</th>
                  <th>H/Ext.</th>
                  <th>Monto H/E.</th>
                  <th>S.Quin.</th>
                  <th>Prima</th>
                  <th>Días N/T.</th>
                  <th>Monto D/N/T.</th>
                  <th>Horas N/T.</th>
                  <th>Monto H/N/T.</th>
                  <th>S.S.O.</th>
                  <th>S.Edu.</th>
                  <th>I.S.L.R.</th>
                  <th>Otros</th>
                  <th>Subtotal</th>
                  <th>Total</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {visibles.map((fila, indice) => (
                  <tr key={fila.id} className={claseFila(fila.tipo_nomina)}>
                    <td>{indice + 1}</td>
                    <td>
                      {fila.nombre} - {fila.tipo}
                    </td>
                    <td>{fila.horas_quincena}</td>
                    <td>{fila.salario_hora}</td>
                    <td>
                      {!cerrada && fila.puede_extra && !fila.pagado ? (
                        <input
                          className="nomina-consulta-input"
                          value={fila.horas_extra}
                          inputMode="decimal"
                          onChange={(event) => cambiarFila(fila.id, 'horas_extra', event.target.value)}
                        />
                      ) : (
                        fila.horas_extra
                      )}
                    </td>
                    <td>{fila.monto_horas_extra}</td>
                    <td>{fila.salario_quincenal}</td>
                    <td>{fila.prima_quincena}</td>
                    <td>{fila.dias_no_trabajados}</td>
                    <td>{fila.monto_dias}</td>
                    <td>{fila.horas_no_trabajadas}</td>
                    <td>{fila.monto_horas}</td>
                    <td>{fila.monto_sso}</td>
                    <td>{fila.monto_seguro_educativo}</td>
                    <td>{fila.islr}</td>
                    <td>
                      {!cerrada && !fila.pagado ? (
                        <input
                          className="nomina-consulta-input"
                          value={fila.otros_descuentos}
                          inputMode="decimal"
                          onChange={(event) => cambiarFila(fila.id, 'otros_descuentos', event.target.value)}
                        />
                      ) : (
                        fila.otros_descuentos
                      )}
                    </td>
                    <td>{fila.subtotal}</td>
                    <td>{fila.total_neto}</td>
                    <td>
                      {!cerrada && !fila.pagado ? (
                        <button type="button" className="admin-btn admin-btn--danger" onClick={() => eliminarFila(fila)}>
                          Eliminar
                        </button>
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default NominaConsultar;
